
<div>
    <rask-input-number
        aid="filterSkogligDataSkotningAvstandMin"
        [label]="texts.skotningAvstandMin"
        [min]="1"
        [max]="skotningAvstandMax"
        [step]="1"
        [isDecimal]="false"
        [isNegative]="false"
        class="skotningavstand-input pe-1"
        [(ngModel)]="skotningAvstandMin"></rask-input-number>
    <rask-input-number
        aid="filterSkogligDataSkotningAvstandMax"
        [label]="texts.skotningAvstandMax"
        [min]="skotningAvstandMaxMinRule"
        [step]="1"
        [isDecimal]="false"
        [isNegative]="false"
        class="skotningavstand-input ps-1"
        [(ngModel)]="skotningAvstandMax"></rask-input-number>
</div>